/**
 * @generated SignedSource<<0ee762c2d93ce1882e75fab415484bf1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type afterReciveInviteStartChatMutation$variables = {
  linkparameter: string;
  recipientid: string;
  requeststatus: number;
};
export type afterReciveInviteStartChatMutation$data = {
  readonly update_insurance_request_log: {
    readonly affected_rows: number;
  } | null | undefined;
  readonly update_request_ai_consult_detail: {
    readonly affected_rows: number;
  } | null | undefined;
};
export type afterReciveInviteStartChatMutation = {
  response: afterReciveInviteStartChatMutation$data;
  variables: afterReciveInviteStartChatMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "linkparameter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "recipientid"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "requeststatus"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "_eq",
        "variableName": "linkparameter"
      }
    ],
    "kind": "ObjectValue",
    "name": "linkparameter"
  }
],
v4 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "affected_rows",
    "storageKey": null
  }
],
v5 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "recipientid",
            "variableName": "recipientid"
          },
          {
            "kind": "Variable",
            "name": "requeststatus",
            "variableName": "requeststatus"
          }
        ],
        "kind": "ObjectValue",
        "name": "_set"
      },
      {
        "fields": [
          {
            "fields": (v3/*: any*/),
            "kind": "ObjectValue",
            "name": "request_ai_consult_details"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "insurance_request_log_mutation_response",
    "kind": "LinkedField",
    "name": "update_insurance_request_log",
    "plural": false,
    "selections": (v4/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "_set",
        "value": {
          "startchatdate": "now()"
        }
      },
      {
        "fields": (v3/*: any*/),
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "request_ai_consult_detail_mutation_response",
    "kind": "LinkedField",
    "name": "update_request_ai_consult_detail",
    "plural": false,
    "selections": (v4/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "afterReciveInviteStartChatMutation",
    "selections": (v5/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "afterReciveInviteStartChatMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "374c5fced33e39ed41619ae5c7669e2c",
    "id": null,
    "metadata": {},
    "name": "afterReciveInviteStartChatMutation",
    "operationKind": "mutation",
    "text": "mutation afterReciveInviteStartChatMutation(\n  $requeststatus: Int!\n  $recipientid: String!\n  $linkparameter: String!\n) {\n  update_insurance_request_log(where: {request_ai_consult_details: {linkparameter: {_eq: $linkparameter}}}, _set: {recipientid: $recipientid, requeststatus: $requeststatus}) {\n    affected_rows\n  }\n  update_request_ai_consult_detail(where: {linkparameter: {_eq: $linkparameter}}, _set: {startchatdate: \"now()\"}) {\n    affected_rows\n  }\n}\n"
  }
};
})();

(node as any).hash = "c8208b737e00f2bb6f343b38c9a13d22";

export default node;
